import React, { useEffect, useState } from 'react';
import Card from './components/Card/Card';
import Header from './layout/Header';
import Footer from './layout/Footer';
import './LandingPage.css';
import monitor from './images/monitor.png';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ArrowLeft from './icons/ArrowLeft';
import ArrowRight from './icons/ArrowRight';
import Chair from './icons/Chair';
import Reviewer from './icons/Reviewer';
import Author from './icons/Author';
import CustomisableTable from './icons/CustomisableTable';
import Dashboard from './icons/Dashboard';
import Workflow from './icons/Workflow';
import Track from './icons/Track';
import Users from './icons/Users';
import CustomisableForm from './icons/CustomisableForm';
import { Button } from './components/Button/Button';
import Accordion from './components/Accordion/Accordion';
import ArrowRightSolidBg from './icons/ArrowRightSolidBg';
import ArrowLeftSolidBg from './icons/ArrowLeftSolidBg';
const SliderCustom: any = Slider;

interface LandingPage {}

const LandingPage: React.FC<LandingPage> = () => {
  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const [viewAllFeatures, setViewAllFeatures] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= 1024;
  });

  const settingsTestimonialsSlider = {
    dots: isMobile ? true : false,
    infinite: false,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    initialSlide: isMobile ? 2 : 0,
    className: 'carousel-slider',
    centerMode: isMobile ? true : false,
    centerPadding: isMobile ? '0' : undefined,
    arrows: !isMobile,
    nextArrow: !isMobile ? (
      <div className="absolute top-0">
        <ArrowRight />
      </div>
    ) : undefined,
    prevArrow: !isMobile ? (
      <div className="absolute top-0">
        <ArrowLeft />
      </div>
    ) : undefined,
  };

  // React Slick settings for roles
  const settingsRolesSlider = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    className: 'carousel-slider',
    nextArrow: (
      <div className="absolute">
        <ArrowRightSolidBg />
      </div>
    ),
    prevArrow: (
      <div className="absolute">
        <ArrowLeftSolidBg />
      </div>
    ),
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1120,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: false,
          dots: false,
          centerMode: true,
          centerPadding: '0',
          arrows: true,
        },
      },
    ],
  };

  const handleMenuClick = (sectionDest: string) => {
    const sectionElement = document.getElementById(sectionDest);
    if (sectionElement) {
      sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const selected = '';
  return (
    <div className="App flex flex-col h-full items-center landing">
      {/* HEADER SECTION */}
      <Header selected={selected ?? ''} handleMenuClick={handleMenuClick} />

      <main>
        {/* INTRO SECTION */}
        <section id="intro" className="intro-section">
          <div className="intro-section-content section-content">
            <div className="mb-8">
              <img src={monitor} alt="Image" />
            </div>
            <div className="intro-section-content-text">
              <h2 className="mb-4">
                <span style={{ color: '#0044f0' }}>chairing</span>
                <span style={{ color: '#00ebcf' }}>tool</span> is a solution for trusted and efficient management of the
                peer review process
              </h2>

              <p className="mb-4">
                Designed to be agile and easy, offering extensive features for large conferences while seamlessly
                adapting to the needs of smaller ones.
              </p>
            </div>
          </div>
        </section>

        {/* KEY FEATURES SECTION */}
        <section id="features" className="features-section">
          <div className="features-content section-content">
            <h2 className="landing">Key Features</h2>

            <div className="text-center">
              <SliderCustom {...settingsTestimonialsSlider}>
                <div key="feature-1">
                  <div className="key-feature-wrapper">
                    <CustomisableTable />
                    <h3>Powerful tracking tables.</h3>
                    <p>
                      Fully customisable tables for analysing information, not only in terms of size, columns to display
                      or their order, but also with the ability to add custom columns, labels and powerful filters.
                    </p>
                  </div>
                </div>

                <div key="feature-2">
                  <div className="key-feature-wrapper">
                    <Dashboard />
                    <h3>Dashboard.</h3>
                    <p>Useful dashboards to quickly see the evolution of different stages and analyse relevant data.</p>
                  </div>
                </div>

                <div key="feature-3">
                  <div className="key-feature-wrapper">
                    <Workflow />
                    <h3>Complete Submission Workflow.</h3>
                    <p>
                      Covers all stages: abstract, full paper, supplementary files, revisions, discussion among
                      reviewers, author notification, camera-ready and any other custom stages you need to add.
                    </p>
                  </div>
                </div>

                <div key="feature-4">
                  <div className="key-feature-wrapper">
                    <CustomisableForm />
                    <h3>Customizables Forms.</h3>
                    <p>
                      Fully customizable forms allowing for independent control over the visibility of questions to
                      authors or reviewers.
                    </p>
                  </div>
                </div>

                <div key="feature-5">
                  <div className="key-feature-wrapper">
                    <Users />
                    <h3>Bidding Process.</h3>
                    <p>
                      Enables reviewers to bid on papers, with the ability to set bid options and the number of minimum
                      and maximum bids for each option per reviewer..
                    </p>
                  </div>
                </div>

                <div key="feature-6">
                  <div className="key-feature-wrapper">
                    <Track />
                    <h3>Support for Multiple Tracks.</h3>
                    <p>Unlimited conference tracks, each with customizable settings for independent management.</p>
                  </div>
                </div>
              </SliderCustom>
            </div>
          </div>
        </section>

        {/* ALL FEATURES SECTION */}
        <section id="all-features" className="all-features-section">
          <div className="all-features-content section-content">
            {viewAllFeatures && (
              <>
                <h2 className="mb-6 landing">All features</h2>
                <Accordion key="diverse-roles" title="Diverse Roles">
                  <p>
                    <span className="font-bold">Flexible Role Management for Tailored Workflows.</span> Our platform
                    empowers you to create and manage an unlimited number of roles within your conference workflow.
                    Whether you need roles for Chairs, SPC (Senior Program Committee), Meta-Reviewers, Reviewers,
                    Authors, or any custom role unique to your process, our system allows you to define each role with
                    distinct permissions and access levels. This flexibility ensures that every participant in the
                    process has the exact tools and access they need, enhancing the efficiency and effectiveness of your
                    review process.
                  </p>
                </Accordion>
                <Accordion key="multiple-levels-of-review" title="Multiple levels of review">
                  <p>
                    You can appoint a supervising reviewer role, which allows you to oversee and manage a designated
                    team of reviewers, providing comprehensive oversight of all submissions assigned to them. This
                    feature provides streamlined tracking, ensuring that every review progresses smoothly and maintains
                    high standards across the review process.
                  </p>
                </Accordion>
                <Accordion key="homepage-messages" title="Homepage Messages">
                  <p>
                    <span className="font-bold">Customized Welcome Messages for Different User Roles.</span> First
                    impressions matter. With our rich-format homepage messages, you can create tailored welcome messages
                    for different roles within your conference—whether they're Authors, Reviewers, SPC members, or any
                    other role you've defined. These messages can be customized to provide relevant instructions,
                    updates, or guidance specific to each role, ensuring that every user feels informed and valued from
                    the moment they log in.
                  </p>
                </Accordion>
                <Accordion key="customizables-forms" title="Customizables Forms">
                  <p>
                    <span className="font-bold">Design Your Workflow with Fully Customizable Forms.</span> Our platform
                    provides fully customizable forms that give you control over every detail of your submission and
                    review processes. You can create forms with a wide range of question types, from simple text fields
                    to file uploads, and even include LaTeX for complex formatting. Each form can be configured to
                    control the visibility of questions based on the user’s role—whether they are authors, reviewers, or
                    any other role—ensuring that everyone sees only what they need to see.
                  </p>
                </Accordion>
                <Accordion key="complete-submission-workflow" title="Complete Submission Workflow">
                  <p>
                    <span className="font-bold">Seamlessly Manage Every Stage of the Submission Process.</span> Our
                    platform supports a comprehensive submission workflow that covers every stage of the review process.
                    From initial abstract submissions to full papers, supplementary files, reviews, and even discussions
                    among reviewers, every step is managed within our system. Once reviews are completed, authors
                    receive notifications and can upload their camera-ready versions directly, streamlining the entire
                    process from start to finish. You can also define any other custom steps you need to add.
                  </p>
                </Accordion>
                <Accordion key="file-and-media-handling" title="File and Media Handling">
                  <p>
                    <span className="font-bold">Flexible File Upload and Management Options.</span> You can define
                    exactly what types of files and media your conference will accept, with the ability to set maximum
                    file sizes, also maximum sheets and specify accepted formats such as PDF, DOCX, or ZIP. This
                    flexibility ensures that your submission process accommodates the needs of your authors while
                    maintaining control over the types of content being uploaded.
                  </p>
                </Accordion>
                <Accordion key="email-templates" title="Email Templates">
                  <p>
                    <span className="font-bold">Streamlined Communication with Customizable Email Templates.</span>{' '}
                    Effortlessly manage communications between the Chair and other roles using our customizable email
                    templates. You can define templates for various stages of the review process—such as submission
                    confirmations, review invitations, or decision notifications—ensuring consistent and professional
                    communication throughout your conference.
                  </p>
                </Accordion>
                <Accordion key="committee-invitation" title="Committee Invitation">
                  <p>
                    <span className="font-bold">Efficiently Manage Reviewer Invitations and Tracking.</span> Our bulk
                    invitation feature simplifies the process of inviting reviewers to your conference. Track invitation
                    status in real-time, resend invitations as needed, and apply filters and labels to manage your list
                    of invitees effectively. This feature saves time and ensures you can quickly build and manage your
                    review committee.
                  </p>
                </Accordion>
                <Accordion key="bidding-process" title="Bidding Process">
                  <p>
                    <span className="font-bold">Empower Reviewers with a Flexible Bidding Process.</span> Allow
                    reviewers to participate actively in the assignment process by enabling bidding on papers. You can
                    define bid options and set the minimum and maximum number of bids each reviewer can make, ensuring a
                    fair and efficient allocation of papers that aligns with reviewers' interests and expertise.
                  </p>
                </Accordion>
                <Accordion key="assignment-flexibility" title="Assignment Flexibility">
                  <p>
                    <span className="font-bold">Easily Assign Papers with Manual or Bulk Import Options.</span> Our
                    platform provides flexible paper assignment options, allowing you to manually assign papers to
                    reviewers or use a simple Excel format for bulk import. This flexibility ensures that you can manage
                    the assignment process in a way that best suits your conference needs. Short on time? We also offer
                    automated assignment solutions to free up the chair's time.
                  </p>
                </Accordion>
                <Accordion key="file-download" title="File Download">
                  <p>
                    <span className="font-bold">Convenient Download Options for All Submission Files.</span> Users can
                    easily download submission files, supplementary materials, final versions, or any files uploaded by
                    authors. This feature ensures that all necessary documents are readily accessible at any stage of
                    the review process.
                  </p>
                </Accordion>
                <Accordion key="dashboard" title="Dashboard">
                  <p>
                    <span className="font-bold">Comprehensive Dashboards for Monitoring Progress.</span> Our intuitive
                    dashboards provide a quick overview of the status and progress of your conference. Monitor different
                    stages of the review process, track submissions, reviewer activity, and gain insights through visual
                    data representations. Dashboards allow filtering so you can focus on the metrics that matter most to
                    you.
                  </p>
                </Accordion>
                <Accordion key="powerful-tracking-tables" title="Powerful tracking tables">
                  <p>
                    <span className="font-bold">Advanced Data Analysis with Customizable Tracking Tables.</span> Our
                    platform features powerful tracking tables that allow you to analyze and manage your conference data
                    with precision. Customize the size, order, and visibility of columns, add custom columns, apply
                    filters, and label data to suit your specific needs. This functionality provides you with the
                    flexibility to monitor and manage every aspect of your review process effectively.
                  </p>
                </Accordion>
                <Accordion key="support-for-multiple-tracks" title="Support for Multiple Tracks">
                  <p>
                    <span className="font-bold">Manage Multiple Conference Tracks with Ease.</span> Whether your
                    conference is divided into several tracks or streams, our platform supports an unlimited number of
                    tracks, each with its own customizable settings. This allows for independent management of each
                    track, ensuring that different topics or themes within your conference receive the attention they
                    need without compromising on organization.
                  </p>
                </Accordion>
              </>
            )}

            <div className="mt-4 text-center">
              <Button
                variant="outlined"
                onClick={() => setViewAllFeatures(!viewAllFeatures)}
                className="view-more-button"
              >
                {viewAllFeatures ? 'Hide all features' : 'View all features'}
              </Button>
            </div>
          </div>
        </section>

        {/* ROLES SECTION */}
        <section id="roles" className="roles-section">
          <div className="roles-content section-content">
            <h2 className="mb-10 landing">Roles</h2>

            <div>
              <div className="video-wrapper">
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/SMgxsGTbKek?si=BuDLlMu7eC8YrvIA"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="roles-slider-wrapper">
                {/* https://react-slick.neostack.com/ */}
                <SliderCustom {...settingsRolesSlider}>
                  <Card key="card-21" title="Chairs" image={<Chair />}>
                    <ul>
                      <li>Custom Reviewer Roles</li>
                      <li>Flexible Form Creation</li>
                      <li>Data Exploration Tools</li>
                      <li>Label and Tag Management</li>
                      <li>Customizable Metrics</li>
                      <li>Immediate Data Operations</li>
                      <li>Configurable Views</li>
                      <li>Comprehensive Planning Feature</li>
                      <li>Dashboard for Insights</li>
                      <li>Ongoing Product Innovation</li>
                      <li>Personal Support</li>
                    </ul>
                  </Card>

                  <Card key="card-22" title="Reviewers" image={<Reviewer />}>
                    <ul>
                      <li>Efficient Paper Review Management</li>
                      <li>Save and Resume Work</li>
                      <li>Guided Bidding Process</li>
                      <li>Discussion and Collaboration with other reviewers</li>
                    </ul>
                  </Card>

                  <Card key="card-23" title="Authors" image={<Author />}>
                    <ul>
                      <li>Easy Conference Submission</li>
                      <li>Simple Sign-In Process</li>
                      <li>Easy monitoring of the submission status</li>
                    </ul>
                  </Card>
                </SliderCustom>
              </div>
            </div>
          </div>
        </section>

        <div className="image-background-section">
          {/* ABOUT US SECTION */}
          <section id="about-us" className="about-us-section">
            <div className="about-us-content section-content px-4">
              <h2 className="landing">About us</h2>
              <Accordion key="who-we-are" title="Who we are">
                <p>
                  This initiative was launched and seed-funded by{' '}
                  <b>
                    International Joint Conferences on Artificial Intelligence (
                    <a href="https://www.ijcai.org/">IJCAI</a>)
                  </b>{' '}
                  and developed by <b>Brainful Labs</b>, with the goal of fostering innovation and collaboration across
                  the international AI research community. We are committed to building an secure, reliable, impactful
                  platform that advances knowledge, connects researchers, and promotes responsible progress in
                  artificial intelligence research.
                </p>
              </Accordion>

              <Accordion key="our-mission" title="Our Mission">
                <p>
                  Our mission is to empower chairs with a state-of-the-art tool that simplifies the complexities of the
                  peer review process and conference management.
                </p>
                <p>
                  We strive to deliver an intuitive, reliable, and versatile platform that enhances the quality and
                  efficiency of academic review process, allowing to handle complex workflows with ease.
                </p>
                <p>
                  Through continuous improvement and a deep commitment to understanding the needs of our users, we aim
                  to set new standards in conference management technology, ensuring that every event is executed with
                  precision and excellence.
                </p>
              </Accordion>

              <Accordion key="our-team" title="Our Team">
                <p>
                  Our team is a dynamic group of professionals, each bringing a wealth of experience in organising and
                  managing conferences of all sizes. With years of hands-on experience in the industry, we have
                  encountered firsthand the limitations and challenges presented by existing tools on the market. Driven
                  by a shared vision and a passion for innovation, we are dedicated to creating a solution that not only
                  addresses these gaps but also elevates the entire peer review process management experience.
                </p>
                <p>
                  Our team’s deep understanding of the intricacies involved in planning and executing successful events
                  allows us to approach the development of ChairingTool with a unique perspective. We are committed to
                  crafting a tool that is intuitive and adaptable to the diverse needs of event organisers, from small
                  workshops to large-scale conferences.
                </p>
                <p>
                  As we continue to grow, our focus remains on refining and expanding our platform to ensure it meets
                  the evolving demands of the industry. We believe in the power of collaboration and feedback, which
                  drives our relentless pursuit of excellence. Our goal is to empower event professionals with a tool
                  that not only simplifies their workflow but also enhances the overall experience for authors,
                  reviewers and chairs alike.
                </p>
              </Accordion>

              <Accordion key="future-developments" title="Future Developments">
                <p>
                  We are proud to place our own chairingtool team in the front lines, available to you for personal
                  support throughout your review process and please remember we are in beta phase, meaning we are
                  constantly working on improving our existing tool.
                </p>
                <p>
                  We are also happy to announce, that we are defining an exciting product road map with new features.
                </p>
                <p>
                  We take pride in placing our dedicated chairingtool team at the forefront, ensuring that you receive
                  personalised support throughout your entire review process. Our team is readily available to assist
                  you, providing expert guidance and addressing any questions or challenges you may encounter.
                </p>
                <p>
                  Please keep in mind that chairingtool is currently in its beta phase, and we are continuously working
                  to enhance and refine our platform. Your feedback is invaluable as we strive to improve our existing
                  features and deliver a seamless user experience.
                </p>
                <p>
                  We are also thrilled to announce that we are actively defining an exciting product roadmap, filled
                  with innovative new features that will further elevate your event management experience. Stay tuned
                  for updates as we continue to expand and enrich chairingtool to meet your evolving needs.
                </p>
              </Accordion>
            </div>
          </section>

          {/* CONTACT SECTION */}
          <section id="contact" className="contact-section">
            <div className="contact-content section-content">
              <div className="contact-content-wrapper">
                <h2 className="landing">We would love to hear from you!</h2>

                <div className="contact-section-text">
                  Whether you have questions, feedback, or just want to share your thoughts, we're here to listen. We
                  believe in collaboration and value every piece of input we receive. Your insights help us improve and
                  grow. Don’t hesitate to reach out — our team is ready to assist you. Together, we can make{' '}
                  <span className="font-bold">chairingtool</span> even better!
                </div>
              </div>

              {/* CONTACT FORM */}
              <div className="form-wrapper">
                <h3 className="landing font-bold text-left text-2xl" style={{ color: '#002480' }}>
                  support@chairingtool.com
                </h3>
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer handleClickOpenDialog={() => {}} handleMenuClick={() => {}} />
    </div>
  );
};

export default LandingPage;
